import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { isDevNoteVisible } from "../DevNote";

/**
 * 分頁面板（design system primitive）。
 * 檢視頁/詳情頁（如硬體五類資訊、合約基本+關聯+資產）常用。
 *
 *   <Tabs tabs={[
 *     { key:"basic", label:"基本資訊", content:<Basic/> },
 *     { key:"relation", label:"關聯合約", content:<Relation/>, badge:3 },
 *   ]} />
 *
 * 不傳 activeKey 時內部自管；傳 activeKey/onChange 則受控。
 */
export const Tabs = ({ tabs: allTabs, activeKey, onChange, className }) => {
  // devOnly 的分頁(尚未開放的佔位:專案關聯/合約關聯/維護紀錄…)只在 development 出現,
  // 部署站連分頁都不長出來(2026-09-09 裁示:尚未開放的區塊使用者不該看到)
  const tabs = allTabs.filter((t) => !t.devOnly || isDevNoteVisible());
  const [internal, setInternal] = useState(tabs[0] && tabs[0].key);
  const active = activeKey !== undefined ? activeKey : internal;
  const setActive = (k) => {
    if (onChange) onChange(k);
    if (activeKey === undefined) setInternal(k);
  };

  return (
    <div className={className}>
      <Nav tabs className="mb-3">
        {tabs.map((t) => (
          <NavItem key={t.key}>
            <NavLink
              href="#"
              className={classnames({ active: active === t.key })}
              disabled={t.disabled}
              onClick={(e) => { e.preventDefault(); setActive(t.key); }}
            >
              {t.icon ? <i className={`mdi ${t.icon} me-1`} /> : null}
              {t.label}
              {t.badge != null ? <span className="badge bg-light text-muted ms-1">{t.badge}</span> : null}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={active}>
        {tabs.map((t) => (
          <TabPane tabId={t.key} key={t.key}>
            {active === t.key ? t.content : null}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};
Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      devOnly: PropTypes.bool,
      label: PropTypes.node.isRequired,
      content: PropTypes.node,
      icon: PropTypes.string,
      badge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      disabled: PropTypes.bool,
    })
  ).isRequired,
  activeKey: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Tabs;
